import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
const BaseIcon = React.forwardRef((_a, ref) => {
    var _b;
    var { focusable = false, children, size = 'md' } = _a, rest = __rest(_a, ["focusable", "children", "size"]);
    const sizesMap = {
        lg: 32,
        md: 24,
        sm: 16
    };
    return (_jsx("svg", Object.assign({ ref: ref, width: (_b = sizesMap[size]) !== null && _b !== void 0 ? _b : size, viewBox: '0 0 192 192', focusable: focusable, fill: 'currentColor' }, rest, { children: children })));
});
export default BaseIcon;
